import { type CUSTOMER_DATA_TAB, CUSTOMER_DATA_TABS, type OVERVIEW_TAB, OVERVIEW_TABS } from 'cpool-constants';

export const OVERVIEW_TAB_PATHS = {
    [OVERVIEW_TABS.BANK_REQUEST]: 'bank-request',
    [OVERVIEW_TABS.CUSTOMER_DATA]: 'customer-data',
    [OVERVIEW_TABS.DOCUMENT_CENTER]: 'document-center',
    [OVERVIEW_TABS.HISTORY]: 'history',
    [OVERVIEW_TABS.OFFER_MANAGEMENT]: 'offer-management',
} as const satisfies Record<OVERVIEW_TAB, string>;

export const CUSTOMER_DATA_TAB_PATHS = {
    [CUSTOMER_DATA_TABS.EMPLOYMENT]: 'employment',
    [CUSTOMER_DATA_TABS.INCOME_AND_EXPENSES]: 'income-and-expenses',
    [CUSTOMER_DATA_TABS.LIVING_SITUATION]: 'living-situation',
    [CUSTOMER_DATA_TABS.PERSONAL_DATA]: 'personal-data',
    [CUSTOMER_DATA_TABS.REAL_ESTATE]: 'real-estate',
} as const satisfies Record<CUSTOMER_DATA_TAB, string>;

export type CUSTOMER_DATA_TAB_PATH = (typeof CUSTOMER_DATA_TAB_PATHS)[keyof typeof CUSTOMER_DATA_TAB_PATHS];

export const CREATE_APPLICANT_TAB_PATHS = {
    ...CUSTOMER_DATA_TAB_PATHS,
    EXISTING_CREDITS: 'existing-credits',
} as const;

export type CreateApplicantTab = keyof typeof CREATE_APPLICANT_TAB_PATHS;
export type CreateApplicantTabPath = (typeof CREATE_APPLICANT_TAB_PATHS)[CreateApplicantTab];
